import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { notification } from 'antd';

import { fetch as axios } from '../../axios_config';

import { handleRejectedResponse } from './utils';

export const FetchAddress = createAsyncThunk(
  'address/get-address/:addressId',
  async (addressId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${process.env.OPULENT_NODE_API_URL}/address/get-address/${addressId}`,
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Fetch Address', rejectWithValue);
    }
  }
);

export const CreateAddress = createAsyncThunk(
  'address/create-address',
  async (body, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.OPULENT_NODE_API_URL}/address/create-address`,
        body
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Create Address', rejectWithValue);
    }
  }
);

export const UpdateAddress = createAsyncThunk(
  'address/edit-address/:addressId',
  async (data, { rejectWithValue }) => {
    try {
      const { addressId } = data;
      delete data.addressId;

      const response = await axios.patch(
        `${process.env.OPULENT_NODE_API_URL}/address/edit-address/${addressId}`,
        data
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Update Address', rejectWithValue);
    }
  }
);

export const DeleteAddress = createAsyncThunk(
  'address/delete-address/:addressId',
  async (addressId, { rejectWithValue }) => {
    try {
      const response = await axios.delete(
        `${process.env.OPULENT_NODE_API_URL}/address/delete-address/${addressId}`
      );
      return response?.data;
    } catch (err) {
      return handleRejectedResponse(err, 'Delete Address', rejectWithValue);
    }
  }
);

const address = createSlice({
  name: 'address',
  initialState: {
    fetchingAddress: false,
    addressInfo: {},
    deletingAddress: false,
    creatingAddress: false,
    updatingAddress: false,
  },
  reducers: {
  },
  extraReducers: {
    [FetchAddress.pending]: (state) => {
      state.fetchingAddress = true;
    },
    [FetchAddress.fulfilled]: (state, action) => {
      const { data } = action?.payload || {};

      state.addressInfo = data;
      state.fetchingAddress = false;
    },
    [FetchAddress.rejected]: (state) => {
      state.fetchingAddress = false;
    },

    [UpdateAddress.pending]: (state) => {
      state.updatingAddress = true;
    },
    [UpdateAddress.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.updatingAddress = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [UpdateAddress.rejected]: (state) => {
      state.updatingAddress = false;
    },

    [CreateAddress.pending]: (state) => {
      state.creatingAddress = true;
    },
    [CreateAddress.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.creatingAddress = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [CreateAddress.rejected]: (state) => {
      state.creatingAddress = false;
    },

    [DeleteAddress.pending]: (state) => {
      state.deletingAddress = true;
    },
    [DeleteAddress.fulfilled]: (state, action) => {
      const { message, success } = action?.payload || {};

      state.deletingAddress = false;
      notification[success ? 'success' : 'error']({
        message,
        top: 65,
      });
    },
    [DeleteAddress.rejected]: (state) => {
      state.deletingAddress = false;
    },
  },
});

const { reducer, actions } = address;

export const { } = actions;

export default reducer;
